import Searchbar from 'components/ui/base/searchbar';
import { H4 } from 'components/ui/base/typography';
import Fuse from 'fuse.js';
import useBusinessRules from 'hooks/useBusinessRules';
import { FC, useEffect, useMemo, useState } from 'react';
import { BusinessRule } from 'store/business-rules/business-rule';
import { BusinessRulesList } from '../BusinessRulesList';
import { DocumentationType } from '../Help';

const AisBusinessRules: FC<{ initFilter?: string }> = ({ initFilter = '' }) => {
    const { aisRules, error, isLoading, getIrelandBusinessRules } = useBusinessRules();
    const [filter, setFilter] = useState<string>(initFilter);

    useEffect(() => {
        if (!aisRules) {
            getIrelandBusinessRules('AIS');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fuse = useMemo(() => {
        if (!aisRules) return;
        return new Fuse(aisRules, {
            keys: ['code', 'description', 'errorMessage'],
            threshold: 0.2,
        });
    }, [aisRules]);

    const filteredList = useMemo(() => {
        // fuse returns no results if filter is an empty string...
        if (filter === '') return aisRules;

        const res: BusinessRule[] | undefined = fuse?.search(filter).map((r) => r.item);
        return res;
    }, [aisRules, fuse, filter]);

    return (
        <div>
            <H4>Revenue error codes</H4>
            <p>
                Submitting a delaration to Revenue can sometimes return an error. The error code comes from the Revenue
                system, not the Ddispatch platform. Below is a list of the ROS codes correct at the time of this
                publication.
            </p>
            <p>
                You can check the actual live Revenue error code list here{' '}
                <span>
                    <a
                        href="https://www.revenue.ie/en/online-services/support/software-developers/documents/ais/ais-business-rules-and-conditions.pdf"
                        rel="noreferrer"
                        target="_blank"
                    >
                        AIS Business Rules and Conditions
                    </a>
                </span>
            </p>
            <p>
                <strong>
                    If an error code was received on one of your declarations, you can search for the error code here.
                </strong>
            </p>
            <Searchbar
                value={filter}
                onSearch={(value) => setFilter(value)}
                inputPlaceholder="Search business rules..."
            />
            {isLoading ? (
                <span>Loading...</span>
            ) : error ? (
                <span>Error loading business rules</span>
            ) : filteredList ? (
                <BusinessRulesList rules={filteredList} type={DocumentationType.AIS} />
            ) : (
                <></>
            )}
        </div>
    );
};
export default AisBusinessRules;
